import { AxiosResponse } from "axios";

import api from "@/api";

import Event from "@/types/Event";
import { WhitelabelProducer } from "@/types/Producer";

export interface GetEventsResponse {
  data: Event[];
}

async function getEvents(page = 1, producer: WhitelabelProducer, category = ""): Promise<AxiosResponse<GetEventsResponse>> {
  const producerId = producer.id.includes("0") ? "0" : producer.id.join(",");

  return await api.get<GetEventsResponse>(`/api/events?page=${page}&producer=${producerId}&category=${category}`);
}

export default getEvents;
